module.exports = __webpack_public_path__ + "static/rendering2-f3b7d6e5e405c3b151fca9b9395b45a3.png";